import * as React from 'react'

import { cn } from '../lib/cn'

/*
 * A loading placeholder: purely decorative, hence `aria-hidden`.
 *
 * The loading state has to be announced once by the container (a `role="status"` with the
 * translated text), not repeated by every grey bar — otherwise a screen reader reads out
 * ten empty rectangles.
 */
export const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  ),
)
Skeleton.displayName = 'Skeleton'
